import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/utils/query-keys';
import { ErgonomicWorkAnalysisService } from '@/infra/services/ergonomic-work-analysis';
import type { UpdateErgonomicWorkAnalysisImageDescriptionRequestDTO } from '@/core/dto/ergonomic-work-analisys/update-image-description';

const Service = ErgonomicWorkAnalysisService.getInstance();

export const useUpdateErgonomicWorkAnalysisImageDescription = () => {
	const queryClient = useQueryClient();

	return useMutation<void, unknown, UpdateErgonomicWorkAnalysisImageDescriptionRequestDTO>({
		mutationFn: async (params) => {
			await Service.updateImageDescription(params);
		},
		onError: () => {
			message.error(I18n.get('Error updating image description'));
		},
		onSuccess: async (_data, variables) => {
			await queryClient.invalidateQueries([
				QUERY_KEYS.GET_ERGONOMIC_WORK_ANALYSIS,
				{
					organization_id: variables.organization_id,
					company_id: variables.company_id,
					id: variables.id
				}
			]);
			await queryClient.invalidateQueries([
				QUERY_KEYS.GET_ERGONOMIC_WORK_ANALYSIS_IMAGES,
				variables.organization_id,
				variables.company_id,
				variables.id
			]);
			message.success(I18n.get('Image description updated successfully'));
		}
	});
};

